import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="logo" >
        <Link to="/" aria-label="Retour à l'accueil" >
         <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
            width="60"
            height="60"
          >
            <defs>
              <style>{`
                .cls-1 { fill: #fff; }
                .cls-2 { fill: #91aea4; }
                .cls-3 { fill: #651747; }
              `}</style>
            </defs>
            <g data-name="Calque 2">
              <g data-name="logos et couelurs choisis">
                <circle className="cls-1" cx="30" cy="30" r="30" />
                <path
                  className="cls-2"
                  d="M54.85,29.1c0-.32,0-.65,0-1C54.88,17.67,50.19,12,43,12c-8.39,0-11.75,5.69-14.57,11.33-2.15,4.3-4.94,10.75-12.73,10.75-9.13,0-10.56-9.74-10.56-9.74a29.19,29.19,0,0,0,2.39,11H45.74V32.45S53.14,33.34,54.85,29.1ZM44,22.43a2.14,2.14,0,1,1,2.13,2.13A2.13,2.13,0,0,1,44,22.43Z"
                />
                <path
                  className="cls-3"
                  d="M30.2,52C43.62,52,51,44.4,53.75,36.69h-46C11.05,44.52,18.09,52,30.2,52Z"
                />
              </g>
            </g>
          </svg>
        </Link>
      </div>

      <div className="burger-menu" onClick={toggleMenu}>
        <div className={`burger-bar ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`burger-bar ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`burger-bar ${isMenuOpen ? 'open' : ''}`}></div>
      </div>

      <nav className={`navigation ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <NavLink to="/" title="Retour à la page d'accueil - Portfolio développeuse web" onClick={closeMenu}>
            Accueil</NavLink>
          </li>

          <li className="has-submenu">
            <NavLink to="/realisations" className="submenu-title" onClick={closeMenu}>
              Mes réalisations
            </NavLink>
            <ul className="submenu">
              <li><NavLink to="/realisations/PGM-refonte-site-WordPress-thème-custom" 
              title="Refonte d'un site sur Wordpress avec un thème custom" onClick={closeMenu}>PGM</NavLink></li>
              <li><NavLink to="/realisations/Binzegger-refonte-site-WordPress-Astra-Elementor" 
              title="Refonte d'un site avec un thème Astra sur Elementor - Wordpress" onClick={closeMenu}>Binzegger</NavLink></li>
              <li><NavLink to="/realisations/Aidadom-refonte-site-WordPress-Elementor" 
              title="Refonte d'un site Elementor - Wordpress" onClick={closeMenu}>Aidadom</NavLink></li>
              <li><NavLink to="/realisations/portfolio-developpement-portfolio" 
              title="Développement du portfolio"onClick={closeMenu}>Portfolio</NavLink></li>
              <li><NavLink to="/realisations/Conception-table-jeux-interactive" 
              title="Conception d'une table interactive" onClick={closeMenu}>Table interactive</NavLink></li>
              <li><NavLink to="/realisations/goldenstarscheerleading-développement-site-WordPress-projet-universitaire-groupe" 
              title="Création d'un site Wordpress avec un thème custom - projet universitaire" onClick={closeMenu}>Site cheerleading</NavLink></li>
              <li><NavLink to="/realisations/realisation-motion-design" 
              title="Realisation d'un motion design sur le machine learning" onClick={closeMenu}>Motion Design</NavLink></li>
              <li><NavLink to="/realisations/creation-supports-de-communication" 
              title="Création de supports de communication sur le thème de la lecture" onClick={closeMenu}>Affiches de Communication</NavLink></li>

  
            </ul>
          </li>

          <li>
            <NavLink to="/mon-parcours" onClick={closeMenu}>Mon parcours</NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
